import type { ConversationDigestApiModel as ConversationSummary } from "@noa/api-core";
import { type FunctionComponent } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRenameConversationForm } from "@noa/ui";
import { Dialog, Form, FormItem, Input } from "~/components/ui";

interface RenameConversationModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  conversation: ConversationSummary;
}

export const RenameConversationModal: FunctionComponent<RenameConversationModalProps> = ({
  isOpen,
  setIsOpen,
  conversation,
}) => {
  const { t } = useTranslation("conversation");
  const {
    control,
    submit,
    cancel,
    isPending,
    formState: { errors },
  } = useRenameConversationForm(conversation, isOpen, () => setIsOpen(false));

  return (
    <Dialog
      title={t("renameModal.title")}
      open={isOpen}
      onOk={submit}
      onCancel={cancel}
      okText={t("actions.rename")}
      cancelText={t("common:cancel")}
      confirmLoading={isPending}
    >
      <Form onSubmit={submit}>
        <FormItem
          required
          label={t("renameModal.nameLabel")}
          validateStatus={errors.name ? "error" : ""}
          help={errors.name ? t("common:formValidations.required") : undefined}
        >
          <Controller name="name" control={control} render={({ field }) => <Input {...field} autoFocus />} />
        </FormItem>
      </Form>
    </Dialog>
  );
};
